/**
 * Formattazione date in italiano, in forma testuale completa:
 * gli screen reader leggono "venerdì 4 settembre alle 17:00"
 * molto meglio di "04/09 17:00" (lineeguida §51).
 */

export function formatDateTimeFull(iso: string, timeZone = 'Europe/Rome'): string {
  const date = new Date(iso);
  const day = new Intl.DateTimeFormat('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone,
  }).format(date);
  const time = new Intl.DateTimeFormat('it-IT', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  }).format(date);
  return `${day} alle ${time}`;
}

/**
 * Orario "segnaposto": il calendario ufficiale non ha ancora fissato l'ora
 * (football-data usa la mezzanotte UTC finché la partita non è schedulata).
 * Mostrare "02:00 di notte" come se fosse vero toglie credibilità.
 */
export function isTimeTBD(iso: string): boolean {
  const d = new Date(iso);
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0;
}

/** Solo la data, senza ora: "sabato 11 ottobre". */
export function formatDateOnly(iso: string, timeZone = 'Europe/Rome'): string {
  return new Intl.DateTimeFormat('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone,
  }).format(new Date(iso));
}

/** Calcio d'inizio: data e ora, oppure "orario da definire" se non schedulato. */
export function formatKickoff(iso: string): string {
  return isTimeTBD(iso) ? `${formatDateOnly(iso)}, orario da definire` : formatDateTimeFull(iso);
}

export function formatDateShort(iso: string, timeZone = 'Europe/Rome'): string {
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  }).format(new Date(iso));
}

/** Punti formattati per l'utente: 3.5 → "3,5", -0.5 → "-0,5". */
export function formatPoints(points: number): string {
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(points);
}
